import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  track(event) {
    const eventName = event.currentTarget.getAttribute('data-tracking-event')
    let properties = event.currentTarget.getAttribute('data-tracked-props')

    properties = JSON.parse(properties)

    window.analytics?.track(eventName, properties)
  }

  trackCollapsed(event) {
    const parent = event.currentTarget.closest('#headingOne') || event.currentTarget.closest('#headingTwo')
    const collapsed = parent.classList.contains('active')

    if (collapsed === true) {
      return
    }

    this.track(event)
  }
}
